import { render, staticRenderFns } from "./ALERT_LIST.vue?vue&type=template&id=7704e6b1&scoped=true"
import script from "./ALERT_LIST.vue?vue&type=script&lang=ts"
export * from "./ALERT_LIST.vue?vue&type=script&lang=ts"
import style0 from "./ALERT_LIST.vue?vue&type=style&index=0&id=7704e6b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7704e6b1",
  null
  
)

export default component.exports